import type { ReactNode } from "react";

import { StickyRegion } from "./StickyRegion";

/** Shared content frame for searchable table and record-list pages. */
export function ListPageLayout({
  heading,
  toolbar,
  children,
}: {
  heading?: ReactNode;
  toolbar?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="space-y-3">
      {heading ? <div className="text-sm font-semibold text-primary">{heading}</div> : null}
      {toolbar ? (
        <StickyRegion className="bg-background/95 backdrop-blur-sm">{toolbar}</StickyRegion>
      ) : null}
      {children}
    </div>
  );
}
